<script lang="ts">
    import { onMount, onDestroy } from "svelte";
    import { fly } from "svelte/transition";

    import tooltipArrow from "../images/arrow-top.svg";

    interface Props {
        text: string;
        rightPosition?: boolean | string;
        leftPosition?: boolean | string;
    }

    let { text, rightPosition = false, leftPosition = false }: Props = $props();

    let tooltipElement: HTMLDivElement;
    let textElement: HTMLSpanElement;
    let toolTipPosition = $state("top-tooltip");

    function hide() {
        textElement?.style.setProperty("visibility", "hidden");
    }
    function show() {
        textElement?.style.setProperty("visibility", "visible");
    }

    onMount(() => {
        if (leftPosition === true) {
            toolTipPosition = "left-tooltip";
        } else if (rightPosition === true) {
            toolTipPosition = "right-tooltip";
        }
        tooltipElement?.parentElement?.addEventListener("mouseenter", show);
        tooltipElement?.parentElement?.addEventListener("mouseleave", hide);
    });

    onDestroy(() => {
        tooltipElement?.parentElement?.removeEventListener("mouseenter", show);
        tooltipElement?.parentElement?.removeEventListener("mouseleave", hide);
    });
</script>

<div bind:this={tooltipElement} in:fly={{ y: 40, duration: 150 }}>
    <div
        bind:this={textElement}
        class="fixed top-[70px] text-sm rounded w-40 px-4 py-2 text-white inset-s-1/2 transform -translate-x-1/2 text-center before:content-[''] before:absolute before:w-full before:h-full before:z-1 before:inset-s-0 before:top-0 before:rounded before:bg-mdark/80 before:backdrop-blur after:content-[''] after:absolute after:z-0 after:w-full after:bg-transparent after:h-full after:-top-4 after:inset-s-0 transition-all {toolTipPosition}"
    >
        <img
            loading="eager"
            src={tooltipArrow}
            class="content-[''] absolute -top-1 inset-s-0 inset-e-0 m-auto w-2 h-1"
            alt="Sub menu arrow"
            style="visibility: hidden;"
            draggable="false"
        />
        <span class="relative z-10">
            {text}
        </span>
    </div>
</div>
